import axios from 'axios';

// アクセストークンをローカルストレージから取得
const getAccessToken = () => localStorage.getItem('access_token');
const getRefreshToken = () => localStorage.getItem('refresh_token');

// アクセストークンを更新して保存
const refreshAccessToken = async () => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/accounts/api/token/refresh/`, {
            refresh: getRefreshToken()
        });
        localStorage.setItem('access_token', response.data.access);
        return response.data.access;
    } catch (error) {
        console.error('Failed to refresh access token:', error);
        return null;
    }
};

// Axios インスタンスを作成
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,  // サーバーのベースURL
});

// リクエストの前にアクセストークンを追加するインターセプター
api.interceptors.request.use(
    (config) => {
        const token = getAccessToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// レスポンスのエラーをチェックし、401エラーならリフレッシュトークンを使ってトークンを再取得するインターセプター
api.interceptors.response.use(
    (response) => response,  // 成功した場合はそのまま返す
    async (error) => {
        const originalRequest = error.config;

        // アクセストークンが失効していて、401エラーが返ってきた場合
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            // リフレッシュトークンを使って新しいアクセストークンを取得
            const newAccessToken = await refreshAccessToken();
            if (newAccessToken) {
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                return api(originalRequest);  // 新しいトークンで再度リクエストを送る
            }
        }

        return Promise.reject(error);
    }
);

export const isAuthenticated = () => {
    const token = getAccessToken();
    return !!token; // トークンが存在すれば true（ログイン状態）
};

export default api;
